"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("styled-components").css`
    &.NextStepCard {
        box-sizing: border-box;
        width: 100%;
        background-color: ${({theme:e,backgroundColor:o})=>o||e.colors.common.light};
        border-radius: 5px;
        overflow: hidden;
        padding: ${({theme:e})=>`${e.spacing.xlarge} ${e.spacing.large}`};
        box-shadow: ${({theme:e})=>e.shadows.low};
        display: grid;
        grid-template-columns: 60px auto 20px;
        align-items: center;
        grid-column-gap: 20px;
        position: relative;

        .NextStepCard-chip {
            margin: 0;
        }

        .NextStepCard-heading {
            margin: 0;
        }

        .NextStepCard-link {
            position: unset;

            &::after {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                cursor: pointer;
            }

            svg {
                margin: 0;
            }

            &:hover,
            &:active,
            &:focus {
                svg {
                    transform: none;
                }
            }
        }
    }
`;exports.default=e,exports.styles=e;
//# sourceMappingURL=styles.js.map
